<!-- Grid Principal do Relatório Regional -->
<p-table [value]="dados" 
        [scrollable]="true" 
        scrollHeight="50vh" 
        scrollDirection="both"
        styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm style p-datatable-sticky-header" 
        [paginator]="false" [loading]="loading"
>
  
  <!-- COLGROUP -->
  <ng-template pTemplate="colgroup">
    <colgroup>
      <col *ngFor="let col of colunasFixasAtivas" [style.width.px]="col.width || 150" />
      <ng-container *ngFor="let familia of familiasUnicas">
        <ng-container *ngIf="familia !== 'TOTAL'">
          <col *ngFor="let col of colunasFamiliaAtivas" [style.width.px]="col.width || 120" />
        </ng-container>
      </ng-container>
      <col style="width: 120px" />
      <ng-container *ngFor="let familia of familiasUnicas">
        <ng-container *ngIf="familia === 'TOTAL'">
          <col *ngFor="let col of colunasFamiliaTotalAtivas" [style.width.px]="col.width || 120" />
        </ng-container>
      </ng-container>
      <col style="width: 80px" />
    </colgroup>
  </ng-template>

  <!-- HEADER agrupado -->
  <ng-template pTemplate="header">
    <tr>
      <th rowspan="2" *ngFor="let col of colunasFixasAtivas; let isFirst = first" 
          [style.text-align]="(col.field === 'lastMonthStk' || col.field === 'showroomTraffic') ? 'center' : 'left'"
          [ngClass]="{
            'fixed-dealer-column': isDealerColumnFixed && col.field === 'name',
            'fixed-lastmonthstk-column': isLastMonthStkColumnFixed && col.field === 'lastMonthStk',
            'fixed-showroom-column': isShowroomColumnFixed && col.field === 'showroomTraffic'
          }"
          [style.left.px]="getFixedColumnPosition(col.field)">
        <div *ngIf="isFirst" class="d-flex align-items-center justify-content-between position-relative">
          <div class="d-flex align-items-center gap-2">
            <button type="button" 
                    class="btn btn-sm btn-outline-light btn-fix-dealer d-flex justify-content-center" 
                    (click)="toggleAllRegions()"
                    [title]="areAllRegionsExpanded() ? 'Recolher Todas' : 'Expandir Todas'">
              <i [class]="getHeaderIconClass()" 
                class="region-toggle-icon"
                title="Expandir/Recolher todas as regiões"></i>
            </button>
            <button type="button" 
                    class="btn btn-sm btn-outline-light btn-fix-dealer d-flex justify-content-center" 
                    (click)="toggleDealerColumnFixed()"
                    [title]="isDealerColumnFixed ? 'Desafixar Coluna Dealer' : 'Afixar Coluna Dealer'">
              <i [class]="getDealerColumnIconClass()" 
                class="region-toggle-icon"
                title="Afixar/Desafixar coluna dealer"></i>
            </button>
          </div>
          <span class="header-title-center">{{ col.header }}</span>
          <div class="header-spacer"></div>
        </div>
        <div *ngIf="col.field === 'lastMonthStk'" class="d-flex align-items-center justify-content-center position-relative">
          <button type="button" 
                  class="btn btn-sm btn-outline-light btn-fix-column d-flex justify-content-center mr-2" 
                  (click)="toggleLastMonthStkColumnFixed()"
                  [title]="isLastMonthStkColumnFixed ? 'Desafixar Coluna LastMonthSTK' : 'Afixar Coluna LastMonthSTK'">
            <i [class]="getLastMonthStkColumnIconClass()" 
              class="region-toggle-icon"
              title="Afixar/Desafixar coluna LastMonthSTK"></i>
          </button>
          <span class="header-title-center">{{ col.header }}</span>
        </div>
        <div *ngIf="col.field === 'showroomTraffic'" class="d-flex align-items-center justify-content-center position-relative">
          <button type="button" 
                  class="btn btn-sm btn-outline-light btn-fix-column d-flex justify-content-center mr-2" 
                  (click)="toggleShowroomColumnFixed()"
                  [title]="isShowroomColumnFixed ? 'Desafixar Coluna Showroom' : 'Afixar Coluna Showroom'">
            <i [class]="getShowroomColumnIconClass()" 
              class="region-toggle-icon"
              title="Afixar/Desafixar coluna Showroom"></i>
          </button>
          <span class="header-title-center">{{ col.header }}</span>
        </div>
      </th> 
      <ng-container *ngFor="let familia of familiasUnicas; let isFirst = first; trackBy: trackByFamiliaIndex">
        <ng-container *ngIf="familia !== 'TOTAL'">
          <th [attr.colspan]="colunasFamiliaAtivas.length" 
              [class.familia-border-left]="isFirst"
              [class.familia-border-left-not-first]="!isFirst"
              style="text-align: center">{{ familia }}</th>
        </ng-container>
      </ng-container>
        <th rowspan="2" style="text-align: center" class="familia-border-left familia-border-right">{{ 'relatorioVeiculos.veiculoRegional.colunas.leadsMarca' | translate }}</th>
      <ng-container *ngFor="let familia of familiasUnicas; trackBy: trackByFamiliaIndex">
        <ng-container *ngIf="familia === 'TOTAL'">
          <th [attr.colspan]="colunasFamiliaTotalAtivas.length" 
              class="familia-border-left-not-first"
              style="text-align: center">{{ familia }}</th>
        </ng-container>
      </ng-container>
      <th rowspan="2" style="text-align: center">C.R.(%)</th>
    </tr>
    <tr>
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index; trackBy: trackByFamiliaIndex">
        <ng-container *ngIf="familia !== 'TOTAL'">
          <th *ngFor="let col of colunasFamiliaAtivas; let colIndex = index; trackBy: trackByColIndex" 
              [class.familia-border-left]="familiaIndex === 0 && colIndex === 0"
              [class.familia-border-left-not-first]="familiaIndex > 0 && colIndex === 0"
              style="text-align: center">
            {{ col.header }}
          </th>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index; trackBy: trackByFamiliaIndex">
        <ng-container *ngIf="familia === 'TOTAL'">
          <th *ngFor="let col of colunasFamiliaTotalAtivas; let colIndex = index; trackBy: trackByColIndex" 
              [class.familia-border-left]="colIndex === 0"
              style="text-align: center">
            {{ col.header }}
          </th>
        </ng-container>
      </ng-container>
    </tr>
  </ng-template>

  <!-- BODY -->
  <ng-template pTemplate="body" let-dealer let-rowIndex="rowIndex">
    <tr [ngClass]="getRowClasses(dealer)" 
        [style.display]="shouldShowDealer(dealer, rowIndex) ? '' : 'none'">
      <!-- Colunas fixas -->
      <td *ngFor="let col of colunasFixasAtivas; let colIndex = index" 
          [style.text-align]="getColumnAlignment(col.field)"
          [ngClass]="{
            'fixed-dealer-column': isDealerColumnFixed && col.field === 'name',
            'fixed-lastmonthstk-column': isLastMonthStkColumnFixed && col.field === 'lastMonthStk',
            'fixed-showroom-column': isShowroomColumnFixed && col.field === 'showroomTraffic'
          }"
          [style.left.px]="getFixedColumnPosition(col.field)">
        
        <!-- Total Regional com dropdown (somente primeira coluna) -->
        <div *ngIf="dealer.isTotalRegiao && colIndex === 0" class="region-total-header">
          <i  [class]="getRegionIconClass(dealer.regiao)" 
              (click)="toggleRegionCollapse(dealer.regiao)"
              class="region-toggle-icon"
              title="Expandir/Recolher região"
              role="button"></i>
          <strong class="region-title">{{ dealer[col.field] }}</strong>
        </div>
        
        <!-- Total Regional outras colunas -->
        <strong *ngIf="dealer.isTotalRegiao && colIndex > 0">{{ dealer[col.field] }}</strong>
        
        <!-- Dealer normal -->
        <span *ngIf="!dealer.isTotalRegiao">{{ dealer[col.field] }}</span>
      </td>

      <!-- Colunas por família (exceto TOTAL) -->
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index">
        <ng-container *ngIf="familia !== 'TOTAL'">
          <td *ngFor="let col of colunasFamiliaAtivas; let colIndex = index" 
              [style.text-align]="'center'"
              [ngClass]="{ 
                'clickable-cell': !dealer.isTotalRegiao,
                'familia-border-left': familiaIndex === 0 && colIndex === 0,
                'familia-border-left-not-first': familiaIndex > 0 && colIndex === 0
              }">
            <strong *ngIf="dealer.isTotalRegiao">{{ getFamiliaData(dealer, familia)[col.field] || 0 }}</strong>
            <span *ngIf="!dealer.isTotalRegiao">{{ getFamiliaData(dealer, familia)[col.field] || 0 }}</span>
          </td>
        </ng-container>
      </ng-container>

      <!-- Coluna Leads Marca -->
      <td [style.text-align]="'center'"
          class="familia-border-left familia-border-right">
        <strong *ngIf="dealer.isTotalRegiao">{{ dealer.leadsMarca || 0 }}</strong>
        <span *ngIf="!dealer.isTotalRegiao">{{ dealer.leadsMarca || 0 }}</span>
      </td>

      <!-- Colunas da família TOTAL -->
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index">
        <ng-container *ngIf="familia === 'TOTAL'">
          <td *ngFor="let col of colunasFamiliaTotalAtivas; let colIndex = index" 
              [style.text-align]="'center'"
              [ngClass]="{ 
                'clickable-cell': !dealer.isTotalRegiao,
                'familia-border-left': colIndex === 0
              }">
            <strong *ngIf="dealer.isTotalRegiao">{{ getValorColunaFamiliaTotal(dealer, col) }}</strong>
            <span *ngIf="!dealer.isTotalRegiao">{{ getValorColunaFamiliaTotal(dealer, col) }}</span>
          </td>
        </ng-container>
      </ng-container>

      <!-- Coluna CR -->
      <td [style.text-align]="'center'">
        <strong *ngIf="dealer.isTotalRegiao">{{ (dealer.crPercentual || 0) | number:'1.1-1' }}%</strong>
        <span *ngIf="!dealer.isTotalRegiao">{{ (dealer.crPercentual || 0) | number:'1.1-1' }}%</span>
      </td>
    </tr>
  </ng-template>

  <!-- FOOTER (BRASIL TOTAL) -->
  <ng-template pTemplate="footer">
    <tr class="total-geral">
      <td [ngClass]="{'fixed-dealer-column': isDealerColumnFixed}"
          [style.left.px]="getFixedColumnPosition('name')">
        <strong>TOTAL</strong>
      </td>
      <td *ngIf="isRelatorioMensal" 
          style="text-align: center" 
          [ngClass]="{'fixed-lastmonthstk-column': isLastMonthStkColumnFixed}"
          [style.left.px]="getFixedColumnPosition('lastMonthStk')">
        <strong>{{ totalizador?.lastMonthStk || 0 }}</strong>
      </td>
      <td style="text-align: center" 
          [ngClass]="{'fixed-showroom-column': isShowroomColumnFixed}"
          [style.left.px]="getFixedColumnPosition('showroomTraffic')">
        <strong>{{ totalizador?.showroomTraffic || 0 }}</strong>
      </td>
      
      <!-- Famílias (exceto TOTAL) -->
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index">
        <ng-container *ngIf="familia !== 'TOTAL'">
          <ng-container *ngFor="let col of colunasFamiliaAtivas; let colIndex = index">
            <td style="text-align: center"
                [class.familia-border-left]="familiaIndex === 0 && colIndex === 0"
                [class.familia-border-left-not-first]="familiaIndex > 0 && colIndex === 0">
              <strong>{{ getValorTotalizador(familia, col.field) || 0 }}</strong>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Leads Marca Total -->
      <td style="text-align: center" class="familia-border-left familia-border-right"><strong>{{ totalizador?.leadsMarca || 0 }}</strong></td>

      <!-- Família TOTAL -->
      <ng-container *ngFor="let familia of familiasUnicas; let familiaIndex = index">
        <ng-container *ngIf="familia === 'TOTAL'">
          <ng-container *ngFor="let col of colunasFamiliaTotalAtivas; let colIndex = index">
            <td style="text-align: center"
                [class.familia-border-left]="colIndex === 0">
              <strong>{{ getValorTotalizador(familia, col.field) || 0 }}</strong>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <td style="text-align: center"><strong>{{ (totalizador?.crPercentual || 0) | number:'1.1-1' }}%</strong></td>
    </tr>
  </ng-template>
</p-table>